var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},".st0{fill:#0f482a}"),React.createElement("path",{"d":"M7.5 20c-.6 0-1.1-.3-1.5-.8-.6-.9-6-8.9-6-12.3C0 3.1 3.4 0 7.5 0S15 3.1 15 6.9c0 3.5-5.4 11.4-6 12.3-.4.5-.9.8-1.5.8zm0-18C4.6 2 2 4.3 2 6.9 2 9 5.3 14.6 7.5 17.8 9.7 14.5 13 8.9 13 6.9 13 4.3 10.4 2 7.5 2z","key":1}),React.createElement("path",{"d":"M7.5 11C5.6 11 4 9.4 4 7.5S5.6 4 7.5 4 11 5.6 11 7.5 9.4 11 7.5 11zm0-5C6.7 6 6 6.7 6 7.5S6.7 9 7.5 9 9 8.3 9 7.5 8.3 6 7.5 6z","key":2})]);
}

Pin.defaultProps = {"version":"1.1","x":"0","y":"0","width":"15","height":"20","viewBox":"0 0 15 20","xmlSpace":"preserve"};

module.exports = Pin;

Pin.default = Pin;
